module.exports = __webpack_public_path__ + "img/stock7.2a4b3541.png";